<template>
  <b-card class="landing-card">
    <div class="text-center mt-2">
      <span class="d-block text-uppercase text-semibold-black text-size-24">
        Please Insert
      </span>
      <span class="d-block text-uppercase text-semibold-primary text-size-32">
        ID Card / Passport
      </span>
      <molecule-display-current-date
        class="mt-3"
      ></molecule-display-current-date>
      <molecule-display-current-time
        class="mt-2"
      ></molecule-display-current-time>
    </div>
    <div class="ntdc-label">
      <span class="text-medium-black">NT Data Center</span>
      <div class="text-notice">
        Privacy Notice: The Site Access system records your facial image and
        personal data to verify your identity and keep records for future
        review.
      </div>
    </div>
    <b-img
      fluid
      :src="landingImage"
      class="landing-image"
      alt="Landing Self Check-in"
    />
  </b-card>
</template>

<script>
import { BCard, BImg } from "bootstrap-vue"
import MoleculeDisplayCurrentDate from "./MoleculeDisplayCurrentDate.vue"
import MoleculeDisplayCurrentTime from "./MoleculeDisplayCurrentTime.vue"
export default {
  name: "MoleculeLandingCard",

  components: {
    BCard,
    BImg,
    MoleculeDisplayCurrentDate,
    MoleculeDisplayCurrentTime,
  },

  data() {
    return {
      landingImage: require("@/assets/images/pages/calendar-illustration.png"),
    }
  },
}
</script>

<style lang="scss" scoped>
.landing-card {
  position: relative;
  height: 550px;
  width: 600px;
}

.ntdc-label {
  position: absolute;
  bottom: 21px;
  left: 21px;
}

.text-notice {
  margin-top: 2px;
  width: 55%;
  font-size: 8px;
}

.landing-image {
  position: absolute;
  bottom: 21px;
  right: 21px;
}
</style>
